import { GetServerSideProps } from 'next';
import { Noto_Sans_SC } from 'next/font/google';

export const notosans = Noto_Sans_SC({ subsets: ['latin'] });

const Index = () => {
  const ulliList = [
    {
      title: 'What Information We Collect',
      desc: `<b>1.1 Login Information.</b> We provide you with login functionality using your Email address or Google account. When you log in, we collect your Account ID and other account information provided by these services to create your Platform identity.

<b>1.2 Device information.</b> When you use our Services through the Platforms, in order to make sure you use our Services normally and the functions operate smoothly and safely, improve and optimize your use experience, and protect your account security, we will collect your device and log information as follows: Include device model, system language, country, operating system, and system version number.

<b>1.3 Feedback information.</b> When you contact us for feedback or customer service, we will collect the information and material that you submitted, your contact information (such as your phone number, email address), so that we could contact you and answer your questions or provide other customer services to you.

<b>1.4 Your input and output.</b> Such as text, images and video inputs and other prompts you provide, and the videos and other output you create.

<b>1.5 Payment and subscription data,</b> needed to complete transactions and process your subscription, such as your payment card or bank account information (collected by our payment processors on our behalf) and transaction history.

<b>1.6 Action logs.</b> We may conduct the de-identification research and statistical analysis for the action logs (such as click records, and use records of materials) generated when you use the functions or services related to this product, to improve the product and service quality of the platform. You can actively close and join the user experience improvement program. If you turn this option off, we will not get the above information.

<b>1.7 Information from Third-party sources.</b> We may collect or receive personal information from other sources, such as Marketing and event partners (e.g., joint marketing partners and event co-sponsors) and Login integration partners (e.g., when you choose to access the Services through your email account, such as through Gmail).

<b>1.8 Other data that you provide to us,</b> which we will use as described in this Privacy Policy or as otherwise disclosed at the time of collection.

In order to realize image and video processing quickly and accurately, we may need to upload the material or material tags to be processed to the cloud server for effect processing. The uploaded materials or tags are only used for image/video effect processing through related functions. We will not store the materials, tags and any related information for more than necessary time, or use them for any other purpose besides this, or Provide to third parties.`,
    },
    {
      title: 'Which permissions we might ask you to authorize',
      desc: `In order to provide you with more high-quality, efficient products and services and improve your service experience, When you use our Services on the web, we process information based on your interactions and choices:

<b>• Account Login:</b> You can create an account and log in using your Email address or Google account. When using Google account, we will receive the identifier and (if you choose to share) your email address provided by Google.

<b>• Login Status:</b> To maintain your login session, we use cookies to store a session token.

<b>• File Upload (Photo/Video):</b> When you need to edit videos or use cloud storage functions, you can manually select files from your device by clicking the &apos;Upload&apos; button. The files you select will be uploaded and temporarily stored on our servers for processing. They will be deleted in accordance with our data retention policy after processing. We cannot directly access your entire device photo album or media library.

<b>• Operation State Saving:</b> To enhance your user experience, such as saving unfinished drafts or remembering your interface preferences (e.g., language, theme), we use your browser&apos;s local storage (LocalStorage) technology. This data is stored locally on your device.

<b>• Browser Information:</b> To identify your client type (e.g., browser, operating system) for service compatibility optimization, we collect your User-Agent string.

<b>• Gets the current network status:</b> to alert users whether they are currently using the mobile network or determine whether a user&apos;s wifi network is available;

You can manage cookies and local storage data through your browser settings. Please note that disabling essential cookies may affect your use of the core functions of our Services.`,
    },
    {
      title: 'How We Collect Your Information',
      desc: `We collect information in different ways.

<b>We collect information directly from you.</b> We collect information directly from you when you provide it to us, such as when you upload files, create an account, or contact customer services.

<b>We collect information from you passively.</b> We use tracking tools like browser cookies and local storage for collecting information about your usage of our Website as described in Section 2 and Section 5.

<b>We collect information from third parties</b> as described in Section 1.7.`,
    },
    {
      title: 'How We Use Your Personal Information',
      desc: `We may use the information you have provided pursuant to this Policy to provide our Services, or to communicate with you. Specifically, we may use your information for the following purposes:

<b>• To Provide and Maintain the Service:</b> To operate the Platform, process your logins, fulfill your requests (e.g., video generation, processing uploads), complete transactions, and communicate with you regarding the service.

<b>• For Customer Support:</b> To respond to your inquiries, troubleshoot issues, and maintain records of our communications.

<b>• For Security and Integrity:</b> To protect our Services, users, and rights; to detect and prevent fraud, abuse, or illegal activity; and to ensure platform stability. This includes pre-screening or scanning uploaded content for potentially illegal content.

<b>• To Improve Our Services:</b> To conduct de-identified research, analyze trends, and enhance the quality, functionality, and user experience of our Products.

<b>• For Legal Compliance:</b> To comply with applicable laws, regulations, legal processes, or enforceable governmental requests. We store and maintain your information for our legal obligations, for example, to record, audit, analyze and dispose your information according to applicable laws in case of emergency.

<b>• To Send Important Notices,</b> such as alerts about your account and changes to our terms, conditions, and policies.

<b>Please note that, according to the related laws &amp; regulations and national standards, our collection and use of personal information do not need your authorization and consent under the following circumstances:</b>

1. Those related to our performance of obligations under the laws &amp; regulations;

2. Those related to the national security and national defense security;

3. Those related to the public security, public health, and major public interests;

4. Those directly related to criminal investigation, prosecution, trial, and execution of judgments;

5. Those that are difficult to obtain your consent, for the purpose of protecting your and others&apos; life, property and other major lawful rights &amp; interests;

6. The collected personal information is disclosed by you to the public;

7. Collect the personal information from legally and publicly disclosed information, such as legal news reports, government information disclosure and other channels;

8. Those required when you sign and perform the related agreements or other written documents;

9. Those necessary for maintaining the safe &amp; stable operation of products or services that are provided, such as discovering and disposing of the faults of products and/or services;

10. Other circumstances specified by the laws &amp; regulations.`,
    },
    {
      title: 'Use of Cookies and Similar Technologies',
      desc: `When you use our Services, certain information may be stored locally on your mobile device using &quot;cookies&quot; or similar technologies such as Google Analytics and web beacons.

<b>5.1 Cookies.</b>

A cookie is a small text file or data file used to store limited information about the user of the device and is stored on your device. We use cookies for essential purposes only, primarily to maintain your login state and ensure service security. This is necessary for the performance of a contract with you (providing the service you request).

We also use your browser&apos;s local storage technology to save your operation state (e.g., drafts, preferences) locally on your device, which is based on our legitimate interest to improve your user experience.

These technologies are essential and do not require prior consent. You can manage them through your browser settings. If you choose to decline cookies, you may not be able to fully experience the interactive features of our Services.

<table style="border:1px solid black;border-collapse:collapse;width:100%;margin-top:20px"><tr style="border:1px solid black;border-collapse:collapse"><th style="border:1px solid black;border-collapse:collapse;padding:8px">Cookie Name</th><th style="border:1px solid black;border-collapse:collapse;padding:8px">Type</th><th style="border:1px solid black;border-collapse:collapse;padding:8px">Purpose</th><th style="border:1px solid black;border-collapse:collapse;padding:8px">Legal Basis</th></tr><tr style="border:1px solid black;border-collapse:collapse"><td style="border:1px solid black;border-collapse:collapse;padding:8px">userInfo</td><td style="border:1px solid black;border-collapse:collapse;padding:8px">Session Cookie</td><td style="border:1px solid black;border-collapse:collapse;padding:8px">Used to maintain the user&apos;s authenticated session after login. This cookie allows the system to recognize the logged-in user across page requests, prevent unauthorized access, and ensure account security.</td><td style="border:1px solid black;border-collapse:collapse;padding:8px">Necessary for the Performance of a Contract</td></tr></table>`,
    },
    {
      title: 'Storage and Retention of Your Information',
      desc: `<b>6.1 Storage of Your Information</b>

The information that we collect from you may be transferred to, and stored at, a destination inside or outside of your country, for the purposes as described in the Policy. By submitting your information, you agree to this transfer, storing or processing. We will take reasonable steps to secure your information and treat it in accordance with the Policy and applicable laws.

<b>6.2 Retention of Your Information</b>

We retain personal information for as long as necessary to provide our Services or fulfill the original or directly related purpose for which such information was collected, or for other business purposes such as complying with our legal obligations, resolving disputes, and enforcing our agreements. We are required by law to keep some types of information for certain periods of time (e.g. statute of limitations). If your personal information is no longer necessary for the legal or business purposes for which it is processed, we will generally destroy or anonymize that information.`,
    },
    {
      title: 'How We Share Your Information',
      desc: `We never sell any personal information to third parties, although it may be shared only when necessary to perform a legitimate business function.

We may share your necessary personal information data to third-party service providers to help us deliver and improve Services, marketing, push/deliver notification bar message, and to help you to share content to third-parties media website, and other legitimate business functions. We will confirm on what basis each third-party will use your personal information and we will ensure that there are adequate safeguards and processes in place to protect your personal data.

We will confirm on what basis each third-party will use your personal information and we will ensure that there are adequate safeguards and processes in place to protect your personal data.

We will disclose or transfer your Information, only if required to do so by law, or we have acquired consent from you, or in the good faith belief that any such action is necessary to: (a) comply with any legal requirements or comply with the legal process served on us or the Platforms; (b) protect and defend the rights or property of us, and (c) act under exigent circumstances to protect the personal safety of our users, or the general public.

We will not share, transfer or disclose your personal information in way of violating this Policy or applicable laws. In the event of a transfer of information that may result from a possible merger, division, acquisition, asset sale, or bankruptcy liquidation by us, we will require the successor to protect your personal information in accordance with laws, regulations, and standards not lower than those set forth in this Policy.`,
    },
    {
      title: 'How We Protect Your Information',
      desc: `We are committed to ensuring that your personal information is secure. In order to prevent unauthorized access, disclosure or other similar risks, we have put in place reasonable physical, electronic and managerial procedures to safeguard and secure the information we collect from your using of our Services on the Platforms. We will use all reasonable efforts to safeguard your personal information.

We review our strategies and update as necessary to meet our business needs, changes in technology, and regulatory requirements. These measures include, but are not limited to, technical and organizational security policies and procedures, security controls and employee training. For example, when you send or receive data from Falcocut App, we make sure they are encrypted using Secure Sockets Layer (&quot;SSL&quot;) or other algorithms.

If we become aware of any breach that affects the security of your personal information, we will provide you with notice as required by applicable laws. By using the Platforms, you agree to accept notice electronically.`,
    },
    {
      title: 'Your Rights',
      desc: `Your local laws may permit you to request that we:

• provide access to and/or a copy of certain information we hold about you

• prevent the processing of your information for direct marketing purposes (including any direct marketing processing based on profiling)

• update information that is out of date or incorrect

• delete certain information which we are holding about you

• restrict the way that we process and disclose certain of your information

• transfer your information to a third-party provider of services

• revoke your consent for the processing of your information

We will consider all requests and provide our response within the time period stated by applicable laws. Please note, however, that certain information may be exempt from such requests in some circumstances, which may include if we need to keep processing your information for our legitimate interests or to comply with a legal obligation. We may request you provide us with the information necessary to confirm your identity before responding to your request.

<b>How to request data access, correction and query</b>

You can click the personal center to enter your personal information editing page so as to access and correct your nickname information.

For other personal information generated during your use of our products or services, if you would like to access or correct it, you can contact us by adopting the methods specified in the privacy policy. As long as we do not require excessive investment, we will reply to your request within 15 days.

<b>How to request data deletion</b>

Cancel account to delete or anonymize your personal information. If you have registered a relevant account, you can choose to cancel your account at any time. You can cancel your account by clicking the personal avatar in the upper right corner - &quot;Cancel Account&quot;. Before you cancel your account, we may need to verify your personal identity, security status, device information, etc. You know and understand that the act of canceling your account is irreversible. When you cancel your account, we will delete or anonymize your personal information, except as otherwise provided by laws and regulations.

In addition, under the following circumstances, you can put forward the request of deleting the personal information by sending a deletion request to the email address: support@falcocut.ai:

a. Our handling of personal information violates the relevant laws and regulations.

b. We collect or use your personal information without your consent.

c. Our handling of personal information violates the agreement with you.

d. You no longer use our products or services, or you cancel your account.

e. We no longer provide you with products or services.

If we decide to respond to your deletion request, we will notify the entities that obtain your personal information from us, and ask them to timely conduct the deletion, unless otherwise specified by laws and regulations, or unless these entities are independently authorized by you.

After you delete the relevant information from our services, we may not immediately delete the corresponding information in the backup system, but we will delete it when the backup is updated.

When you access, modify or delete the relevant information, we may ask you to perform the identity verification so as to ensure the security of the account.

<b>Other requests</b>

If you need to exercise other rights or make other requests to us, you may contact us by adopting the methods specified in the privacy policy. As long as we do not require excessive investment, we will reply to your request within 15 days.`,
    },
    {
      title: 'Minor&apos;s/Children&apos;s Privacy',
      desc: `The Platform is not intended for Children. Children under the age of 16 (or other age specified by the law applicable to your region) must not use the Platform for any purpose without first obtaining parental/guardian&apos;s consent to this Privacy Policy (both for themselves and on your behalf). We do not knowingly collect personally identifiable information from children.

It is our policy not to require personal information from minors or offer to send any promotional materials to persons in that category. We do not seek or intend to seek to receive any personal information from minors. Should a parent or guardian have reasons to believe that a minor has provided us with personal information without their prior consent, please contact us to ensure that the personal information is removed and the minor unsubscribes from any of our applicable Services.`,
    },
    {
      title: 'Modification of This Policy',
      desc: `The effective date of this Policy is set forth at the top of this webpage. We reserve the right to amend this Policy at any time with or without notice and will place any updates on this webpage. The amended Policy supersedes all previous versions. Your continued use of Services on the Platforms will be taken as acceptance of the updated Privacy Policy.`,
    },
    {
      title: 'How to Contact Us',
      desc: `If you have any question/complain/suggestion/request regarding this Policy, you may also contact us directly at:

Email: support@falcocut.ai`,
    },
  ];
  return (
    <div className="w-full h-full flex justify-center">
      <div className="w-[650px] pt-[200px]">
        <h1 className="text-[48px] font-[500] leading-[56px]">Privacy Policy</h1>
        <p className="text-[15px] leading-[24px] py-[12px]">
          Effective Date - January 5, 2026
        </p>
        <p className="whitespace-pre-wrap leading-[24px] py-[12px]">
          <b>Welcome to Falcocut Web Service (the &quot;Platform&quot;).</b> The Platform
          is provided and controlled by 【Quvideo (Hong Kong) Limited】 (&quot;we&quot;,
          &quot;us&quot;, &quot;our&quot;). This Privacy Policy (the &quot;Policy&quot;)
          sets out the basis on which any information we collect from you, or that you
          provide to us, will be processed by us. Please read the following contents
          carefully to understand our practices regarding your information. By accessing
          or using the Platform, services, applications, products and content
          (collectively, the &quot;Services&quot;), you acknowledge the practices
          described in the Policy. For purposes of the Policy, &quot;you&quot; and
          &quot;your&quot; means you as the user of the Services.
          <br />
          <br />
          <b>
            IF YOU DO NOT AGREE WITH ANY TERM IN THIS POLICY, PLEASE DO NOT USE OUR
            SERVICES.
          </b>
          <br />
          <br />
          To give you an overview, this Privacy Policy is structured as follows:
        </p>
        <ul style={{ listStyle: 'decimal', paddingLeft: '35px', paddingBottom: '20px' }}>
          {ulliList.map((item, index) => (
            <li className="leading-[24px]" key={index}>
              {item.title}
            </li>
          ))}
        </ul>
        <div className="pb-[200px]">
          {ulliList.map((item, index) => (
            <div key={index} style={{ marginBottom: '20px' }}>
              <h2 className="text-[36px] font-[500] leading-[44px] py-[32px]">
                {`${index + 1}. ${item.title}`}
              </h2>
              <div
                style={{ whiteSpace: 'pre-wrap', lineHeight: '24px' }}
                dangerouslySetInnerHTML={{ __html: item.desc }}
              />
            </div>
          ))}
          <h2 className="text-[36px] font-[500] leading-[44px] py-[32px]">
            SUPPLEMENTAL TERMS ‒ JURISDICTION SPECIFIC
          </h2>
          <p className="whitespace-pre-wrap leading-[24px] mb-[24px]">
            In the event of a conflict between the provisions of the Supplemental Terms ‒
            Jurisdiction Specific that is relevant to your jurisdiction from which you
            access or use the Services, and the rest of the Policy, the relevant
            jurisdiction&apos;s Supplemental Terms ‒ Jurisdiction Specific will supersede
            and control.
          </p>
          <h3 className="text-[32px] font-[500] leading-[40px] py-[24px]">
            Addendum for EEA and Switzerland Residents
          </h3>
          <p className="whitespace-pre-wrap leading-[24px] mb-[24px]">
            If you are using the Services in the European Economic Area (&quot;EEA&quot;)
            and Switzerland, the following additional terms apply:
          </p>
          <p className="whitespace-pre-wrap leading-[24px] mb-[16px]">
            <b>Your Special Rights</b>
          </p>
          <p className="whitespace-pre-wrap leading-[24px] mb-[12px]">
            You have the following rights:
          </p>
          <p className="whitespace-pre-wrap leading-[24px] mb-[12px]">
            • <b>The right to request free of charge</b> (i) confirmation of whether we
            process your personal data and (ii) access to a copy of the personal data
            retained;
          </p>
          <p className="whitespace-pre-wrap leading-[24px] mb-[12px]">
            • <b>The right to request</b> proper rectification or removal of your personal
            data or restriction of the processing of your personal data;
          </p>
          <p className="whitespace-pre-wrap leading-[24px] mb-[12px]">
            • Where processing of your personal data is either based on your consent or
            necessary for the performance of a contract with you and processing is carried
            out by automated means, <b>the right to receive</b> the personal data
            concerning you in a structured, commonly used and machine-readable format or
            to have your personal data transmitted directly to another company, where
            technically feasible (data portability);
          </p>
          <p className="whitespace-pre-wrap leading-[24px] mb-[12px]">
            • Where the processing of your personal data is based on your consent,{' '}
            <b>the right to withdraw</b> your consent at any time without impact to data
            processing activities that have taken place before such withdrawal;
          </p>
          <p className="whitespace-pre-wrap leading-[24px] mb-[12px]">
            • <b>The right not to be subject</b> to any automatic individual decisions,
            including profiling, which produces legal effects on you or similarly
            significantly affects you unless we have your consent, this is authorized by
            Union or Member State law or this is necessary for the performance of a
            contract;
          </p>
          <p className="whitespace-pre-wrap leading-[24px] mb-[12px]">
            • <b>The right to object</b> to processing if we are processing your personal
            data on the basis of our legitimate interest unless we can demonstrate
            compelling legitimate grounds which may override your right. If you object to
            such processing, we ask you to state the grounds of your objection in order
            for us to examine the processing of your personal data and to balance our
            legitimate interest in processing and your objection to this processing;
          </p>
          <p className="whitespace-pre-wrap leading-[24px] mb-[12px]">
            • <b>The right to object</b> to processing your personal data for direct
            marketing purposes; and
          </p>
          <p className="whitespace-pre-wrap leading-[24px] mb-[24px]">
            • <b>The right to lodge complaints</b> before the competent data protection
            regulator.
          </p>
          <p className="whitespace-pre-wrap leading-[24px] mb-[24px]">
            Before we can respond to a request to exercise one or more of the rights
            listed above, you may be required to verify your identity or your account
            details.
          </p>
          <p className="whitespace-pre-wrap leading-[24px] mb-[24px]">
            Please send an e-mail to us if you would like to exercise any of your rights:
            support@falcocut.ai
          </p>
          <h3 className="text-[32px] font-[500] leading-[40px] py-[24px]">
            Addendum for California Residents
          </h3>
          <p className="whitespace-pre-wrap leading-[24px] mb-[24px]">
            The terms of this Addendum apply to residents of California under the
            California Consumer Privacy Act (&quot;CCPA&quot;) and other applicable laws.
            The CCPA provides California residents with certain legal rights such as
            &quot;do not sell.&quot; These rights are not absolute and are subject to
            certain exceptions.
          </p>
          <p className="whitespace-pre-wrap leading-[24px] mb-[24px]">
            In the past 12 months, we have not sold personal information of California
            residents within the meaning of &quot;sold&quot; in the CCPA.
          </p>
          <p className="whitespace-pre-wrap leading-[24px] mb-[24px]">
            We collect, use, store and share your personal information in the same way as
            described in the main body of this Privacy Policy.
          </p>
          <p className="whitespace-pre-wrap leading-[24px] mb-[16px]">
            <b>Your Special Rights Under the CCPA</b>
          </p>
          <p className="whitespace-pre-wrap leading-[24px] mb-[12px]">
            Request we disclose to you free of charge the following information covering
            the 12 months preceding your request:
          </p>
          <p className="whitespace-pre-wrap leading-[24px] mb-[12px]">
            • the categories of personal information about you that we collected;
          </p>
          <p className="whitespace-pre-wrap leading-[24px] mb-[12px]">
            • the categories of sources from which the personal information was collected;
          </p>
          <p className="whitespace-pre-wrap leading-[24px] mb-[12px]">
            • the purpose for collecting personal information about you;
          </p>
          <p className="whitespace-pre-wrap leading-[24px] mb-[12px]">
            • the categories of third parties to whom we disclosed personal information
            about you and the categories of personal information that was disclosed (if
            applicable) and the purpose for disclosing the personal information about you;
          </p>
          <p className="whitespace-pre-wrap leading-[24px] mb-[24px]">
            • the specific pieces of personal information we collected about you.
          </p>
          <p className="whitespace-pre-wrap leading-[24px] mb-[24px]">
            Request we delete personal information we collected from you, unless CCPA
            recognizes an exemption.
          </p>
          <p className="whitespace-pre-wrap leading-[24px] mb-[24px]">
            Be free from unlawful discrimination for exercising your rights including
            providing a different level or quality of Services or deny goods or Services
            to you when you exercise your rights under the CCPA.
          </p>
          <p className="whitespace-pre-wrap leading-[24px] mb-[24px]">
            We aim to fulfill all verified requests within 45 days pursuant to the CCPA.
            If necessary, extensions for an additional 45 days will be accompanied by an
            explanation for the delay.
          </p>
          <p className="whitespace-pre-wrap leading-[24px]">
            Please submit your request via the following method: support@falcocut.ai
          </p>
        </div>
      </div>
    </div>
  );
};

export default Index;

export const getServerSideProps: GetServerSideProps = async (context) => {
  // let isLoggedIn = false;
  // const userInfo = context.req.cookies['userInfo'];
  // const user = context.req.cookies['user'];
  // if (userInfo && user) {
  //   isLoggedIn = true;
  // }
  let returnData = {
    props: {},
  };
  // if (isLoggedIn) {
  //   returnData = {
  //     ...returnData,
  //     // @ts-ignore
  //     redirect: {
  //       destination: homeURL,
  //       permanent: false,
  //     },
  //   };
  // } else {
  //   returnData = {
  //     ...returnData,
  //     // @ts-ignore
  //     // redirect: {
  //     //   destination: '/home',
  //     //   permanent: false,
  //     // },
  //   };
  // }
  return returnData;
};
